import { gql } from '@/__generated__';

export const GET_MOVEMENT_DATA = gql(`#graphql
  query GetMovementData($movementId: Int!) {
    gateMovement(id: $movementId) {
      gate {
        id
        dataConfiguration {
          minPosition
          maxPosition
        }
        movements2 {
          id
          lastPosition {
            value
            unit
            precision
            source
            timestamp
          }
          lastBattery {
            value
            unit
            precision
            source
            timestamp
          }
          unit
          precision
          operatingState
        }
      }
      ...GateMovementFragment
    }
  }
`);
